import styled from 'styled-components';

import themConfigs from 'config/theme';

const fullConfig = { theme: themConfigs };

const PageLinkWrapElem = styled.li`
  &::before {
    transition: margin 150ms;
    content: '';
    display: inline-block;
    min-height: 0.625rem;
    min-width: 0.625rem;
    background-image: url('/assets/svg/service-link.svg');
    background-size: contain;
    background-repeat: no-repeat;
    margin-right: 0.5rem;
  }
  &:hover::before {
    margin-right: 0.25rem;
    margin-left: 0.25rem;
  }
`;

const ServiceCardWrap = styled.div`
  min-height: ${(props) => (props.rigidHeight ? '388px' : 'auto')};
  @media (min-width: ${fullConfig.theme.screens.sm}) {
    min-height: 388px;
  }

  @media (min-width: ${fullConfig.theme.screens.md}) {
    min-height: 490px;
  }
`;

const PageLinkElem = styled.a``;

export { ServiceCardWrap, PageLinkWrapElem, PageLinkElem };
